import { useQuery } from '@tanstack/react-query'
import { fetchContent } from '../api/content'
import { FacebookEmbed } from './FacebookFeed'

/**
 * What the studio has posted, for everybody (D-130).
 *
 * **One component, because there were two and they had already drifted.** The
 * parent portal's copy centred the Facebook plugin; the teacher portal's did
 * not — and the plugin is capped at 500px by Facebook, so the uncentred one sat
 * against the left edge of a column three times its width on a laptop. Nobody
 * had compared them, which is the ordinary fate of two implementations of one
 * idea: the second never receives the first's fixes.
 *
 * The audit caught it as the route was being wired, one commit before a parent
 * could have reached the worse of the two by URL (D-322).
 */
export default function StudioNewsPanel() {
  const { data: content } = useQuery({ queryKey: ['content'], queryFn: fetchContent })

  return (
    <>
      <h2 className="mb-1 font-display text-lg">From the studio</h2>
      <p className="mb-4 text-[13px] text-ink-3">
        Closures, recitals and everything else the studio posts.
      </p>

      {/*
        Centred rather than stretched. Facebook's page plugin is capped at 500px
        by Facebook, not by us, so on a laptop it would otherwise sit against the
        left edge with half the column empty beside it.
      */}
      <div className="flex justify-center">
        <FacebookEmbed content={content} />
      </div>
    </>
  )
}
